var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('PaymentItem',{attrs:{"item":_vm.teamRegistrationPayment,"isRegistrationPaymentItem":""}}),_vm._l((_vm.addOnsInfoSummaryList),function(item){return _c('PaymentItem',{key:item.fileMetadataId,attrs:{"item":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }